import MDinput from '@/components/MDinput';
import { validatorRequire } from '@/utils/validators';

export function getFormDefinition(vue) {
  return {
    description: {
      type: MDinput,
      defaultValue: '',
      props: {
        maxlength: 64,
        required: true
      },
      rules: [{ validator: validatorRequire }]
    },
    symbol: {
      type: MDinput,
      defaultValue: '',
      props: {
        caption: 'currency.symbol',
        maxlength: 3,
        required: true
      },
      rules: [{ validator: validatorRequire }]
    },
    isoCode: {
      type: MDinput,
      defaultValue: '',
      props: {
        caption: 'currency.isoCode',
        maxlength: 3,
        required: true
      },
      rules: [{ validator: validatorRequire }]
    }
  };
}

export default getFormDefinition;

export function createItemFromFormData(vue, form) {
  return form;
}

export function createFormDataFromItem(vue, item) {
  const form = {
    ...item
  };
  return form;
}
